import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { FiltroListarIndicador, Indicadores } from "app/types/comissoes/Indicadores";
import clsx from "clsx";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { InputCpfCnpj } from "../../inputs/InputCpfCnpj";
import { Paginacao } from "../../itens-orcamento/paginacao/Paginacao";
import validaCpfCnpj from "app/utils/validarCpfCnpj";

const estiloPesquisaIndicador = require("./pesquisa-indicadores.modules.scss").default;
const estiloBotoes = require("../../../estilos/botoes.module.scss").default;
const estiloFormulario = require('../../../estilos/formulario.module.scss').default;

export type DadosAbaIndicadores = {
  abaIndicadores: Partial<FiltroListarIndicador>;
  indicadores?: Partial<PagedMessageResponse<Indicadores>>;
}

export type PesquisaIndicadorProps = {
  somenteLeitura: boolean;
  exibirBotaoNovo: boolean;
  exibirRazaoSocial: boolean;
  onPesquisarIndicador?: (filtros: FiltroListarIndicador) => void;
  onNovo?: () => void;
  onClickDados?: (codigoIndicador: number) => void;
  onAlteradoDadosIndicadores: (dados: DadosAbaIndicadores) => void;
};

export const PesquisaIndicador = (props: PesquisaIndicadorProps & DadosAbaIndicadores) => {

  const acaoSubmit = (values) => {
    props.onPesquisarIndicador({ ...values, NumeroPagina: 1 });
  };

  const formik = useFormik({
    initialValues: { ...props.abaIndicadores },
    onSubmit: acaoSubmit,
    enableReinitialize: true,
  });

  useEffect(() => {
    props.onAlteradoDadosIndicadores({
      abaIndicadores: formik.values,
      indicadores: props.indicadores,
    });
  }, [formik.values, props.indicadores]);

  const onCpfCnpjModificado = (novoCpfCnpj: string) => {
    formik.setFieldValue("CpfCnpj", novoCpfCnpj);

    if (validaCpfCnpj(novoCpfCnpj)) {
      props.onPesquisarIndicador({
        ...formik.values,
        CpfCnpj: novoCpfCnpj,
        NumeroPagina: 1,
      });
    }
  };

  const formPesquisar = () => {

    const campoCodigo = <>
      <label>Código</label>
      <input
        style={{ width: "120px" }}
        id="pesquisaIndicador-campoCodigo"
        name="Codigo"
        type="text"
        value={formik.values?.Codigo ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </>

    const campoPesquisaNomeIndicador = <>
      <label>Nome</label>
      <input
        style={{ width: "440px" }}
        id="pesquisaIndicador-campoPesquisaNomeIndicador"
        autoFocus
        name="Nome"
        type="text"
        value={formik.values?.Nome ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </>

    const campoPesquisaCnpjCpfIndicador = <>
      <label>CNPJ / CPF</label>
      <InputCpfCnpj
        className="_w-[200px]"
        id="pesquisaIndicador-campoPesquisaCnpjCpfIndicador"
        name="CpfCnpj"
        cpfCnpj={formik.values?.CpfCnpj}
        onCpfCnpjModificado={onCpfCnpjModificado}
        disabled={props.somenteLeitura}
      />
    </>

    const campoInscrEstadual = <>
      <label>Insc. Estadual</label>
      <input
        style={{ width: "200px" }}
        id="pesquisaIndicador-campoInscrEstadual"
        name="InscrEstadual"
        type="text"
        value={formik.values?.InscrEstadual ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </>

    const campoRazaoSocial = props.exibirRazaoSocial ? <>
      <label>Razão Social</label>
      <input
        style={{ width: "440px" }}
        id="pesquisaIndicador-campoRazaoSocial"
        name="RazaoSocial"
        type="text"
        value={formik.values?.RazaoSocial ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </> : null

    const checkboxPesquisaNaoRelacionados = <>
      <label className="_cursor-pointer" htmlFor="pesquisaIndicador-NaoRelacionado">Não Relacionados</label>
      <input
        id="pesquisaIndicador-NaoRelacionado"
        name="Todos"
        type="checkbox"
        checked={formik.values?.Todos ?? false}
        onChange={(e) => formik.setFieldValue("Todos", e.target.checked)}
        disabled={props.somenteLeitura}
      />
    </>

    const botaoPesquisarIndicador = <button
      id="pesquisaIndicador-botaoPesquisarIndicador"
      type="submit"
      className={clsx(`no-global-button !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
    >
      Pesquisar
    </button>

    const botaoNovoIndicador = <button
      id="pesquisaIndicador-botaoNovoIndicador"
      type="button"
      className={clsx(`no-global-button !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
      onClick={() => props.onNovo()}
    >
      Novo
    </button>

    return <form onSubmit={(e) => {
      e.preventDefault();
      formik.handleSubmit();
    }}>
      <div className={`_ml-16 _pt-8 _items-baseline ${estiloFormulario.formulario}`}>
        {campoCodigo}
        {campoPesquisaNomeIndicador}
        {campoPesquisaCnpjCpfIndicador}
        {campoInscrEstadual}
        {campoRazaoSocial}
        {checkboxPesquisaNaoRelacionados}
      </div>

      {!props.somenteLeitura && <div className="_flex _gap-2 _pt-2">
        {botaoPesquisarIndicador}
        {props.exibirBotaoNovo && botaoNovoIndicador}
      </div>}
    </form>
  }

  const listaIndicadores = <div className={`${estiloPesquisaIndicador.tabela}`}>
    <div>
      <div>Nome</div>
      <div>CPF/CNPJ</div>
      <div>Razão Social</div>
      <div>Insc. Estadual</div>
    </div>

    {props.indicadores?.Entities?.map((indicador) => (
      <div
        key={indicador.Codigo}
        id={`pesquisaIndicador-linha-${indicador.Codigo}`}
        className={estiloPesquisaIndicador.linha}
        onClick={() => props.onClickDados(indicador.Codigo)}
      >
        <div>{indicador.Nome.toUpperCase()}</div>
        <div>{indicador.Identificador}</div>
        <div>{indicador.RazaoSocial?.toUpperCase()}</div>
        <div>{indicador.InscrEstadual}</div>
      </div>
    ))}
  </div>

  const paginacaoListaIndicadores = <div className="_my-2">
    {props.indicadores?.PageCount > 1 && (
      <Paginacao
        key={props.abaIndicadores.NumeroPagina}
        paginaAtual={props.abaIndicadores.NumeroPagina}
        totalPaginas={props.indicadores.PageCount}
        id="PesquisaIndicador_Paginacao"
        onAlterarListaSelecionada={(numeroPagina) => {
          props.onPesquisarIndicador({ ...formik.values, NumeroPagina: numeroPagina });
        }}
      />
    )}
  </div>

  return (
    <>
      {formPesquisar()}

      {props.indicadores?.Entities?.length > 0 && (
        <>
          {listaIndicadores}
          {paginacaoListaIndicadores}
        </>
      )}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
